module.exports = __webpack_public_path__ + "media/images/515151nw-8493604f9ee0b1d56865f68a8d49b23e.png";